import { ExtendedCarItem } from '../types';

const getCarTitle = (extendedData: ExtendedCarItem): string => {
  const { model } = extendedData.data;
  if (model?.displayName) {
    return model.displayName;
  }
  return '';
};

export default getCarTitle;
